// Package Imports
import { toJS } from "mobx"

// Project Imports
import AuthStore from "modules/login/store/AuthStore"
import OptimizationStore from "modules/optimization-old/store/OptimizationStore"
import fetchNeedMaster from "utils/fetchNeedMasterData"
import axios from "utils/axios"
import * as APITypes from "constants/API"
import incomeTypeEnum from "constants/incomeTypeEnum"
import FamilyMemberModalTypeEnum from "constants/familyMemberModalTypeEnum";
import StorageKeys from "constants/StorageKeys";
import NeedTypeEnum from "constants/NeedTypeEnum"
import getCookie from "utils/journeyIdCookie/getJourneyId"
import { COOKIE_PARA_NAME_FOR_JOURNEY_ID } from "../../../../../constants/Constants"

const submitDataToTheServer = async (formController, hideRetirementPopUpModal, buttonType) => {


  // !calling the backend api Fetch BI Data based on provided recommendation
  const formFieldValues = formController.get()
  const targetAmountMidValue = formFieldValues.target_amount_dropdown.value.mid_value
  RetirementBiDataApiCall(targetAmountMidValue, hideRetirementPopUpModal, formFieldValues, buttonType)


}

const isValidFunction = async (formController) => {
  const validValue = formController
    .validate({ showErrors: true })
    .then(({ isValid }) => {
      if (!isValid) {
        console.log("Form errors are ", formController.errors())
      }
      return isValid
    })

  return validValue
}


export const onRecommend = async (formController, hideRetirementPopUpModal) => {
  const valid = await isValidFunction(formController)

  if (valid) {
    OptimizationStore.isCalculatorUsed = false
    submitDataToTheServer(formController, hideRetirementPopUpModal, "recommend")
  }
}

export const onSet = async (formController, hideRetirementPopUpModal) => {
  const valid = await isValidFunction(formController)

  if (valid) {
    OptimizationStore.isCalculatorUsed = false
    submitDataToTheServer(formController, hideRetirementPopUpModal)
  }
}

export const onLaunch = async (formController, openRetirementCalculator, getFamilyMemberType) => {
  const valid = await isValidFunction(formController)
  if (valid) {
    openRetirementCalculator()
    getFamilyMemberType()
  }
}

export const RetirementBiDataApiCall = async (targetAmountValue, hideModal = OptimizationStore.resetSelectedNeedAndMemberId, formFieldValues, buttonType) => {

  let masterData = await fetchNeedMaster()

  if (masterData.length <= 0) return

  let selectedNeedId = masterData.find((singleNeed) => singleNeed.unique_name === OptimizationStore.selectedNeed).id

  let recommendationReqDataToBeSubmitted = {
    "user_journey": getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID),
    "family": OptimizationStore.selectedFamilyMemberId,
    "need": selectedNeedId,
    "target_amount_value": OptimizationStore.isCalculatorUsed ? targetAmountValue : "",
    "payout_mode": buttonType === "recommend" ? "RECOMMENDED_INCOME" : incomeTypeEnum.INCOME.toLowerCase(),
    "target_amount": OptimizationStore.isCalculatorUsed || buttonType === "recommend" ? null : formFieldValues.target_amount_dropdown.value.id,
    "is_selected": true,
  }

  switch (OptimizationStore.familyMemberModalType) {
    case FamilyMemberModalTypeEnum.CHANGE_LA:
      // props.changeLA()
      OptimizationStore.changeLA(recommendationReqDataToBeSubmitted, hideModal,NeedTypeEnum.SAVE_FOR_RETIREMENT)
      return

    case FamilyMemberModalTypeEnum.ADD_INSURED:
      let familyMemberData = OptimizationStore.fetchFamilyMemberListForLifeAssured().find((item) => item.id === OptimizationStore.selectedFamilyMemberId);
      const addInsuredObj = {
        family_member_id: OptimizationStore.selectedFamilyMemberId,
        user_journey_id: getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID),
        need_id: selectedNeedId,
        is_selected: true,
        target_amount_id:  OptimizationStore.isCalculatorUsed || buttonType === "recommend" ? null : formFieldValues.target_amount_dropdown.value.id,
        target_amount_value: OptimizationStore.isCalculatorUsed ? targetAmountValue : "",
        is_calculator_used: OptimizationStore.isCalculatorUsed,
        payout_mode: buttonType === "recommend" ? "RECOMMENDED_INCOME" : incomeTypeEnum.INCOME.toLowerCase(),
        dob: familyMemberData.dob,
        monthly_income: familyMemberData.monthly_income,
      };

      let responseData = await axios.post(APITypes.ADD_INSURED, addInsuredObj);

      if (responseData.data.status !== "error") {
        localStorage.setItem(StorageKeys.FIRST_TIME_OPTIMIZATION_PAGE_LOAD_PARAM, false);
        OptimizationStore.addInsuredData(responseData.data, hideModal);
      }

      return;

    case FamilyMemberModalTypeEnum.ADD_NEED:
      let journeyData = toJS(AuthStore.journeyData)
      let memberData = journeyData.family_details_list.find((member) => member.id === OptimizationStore.selectedFamilyMemberId)
      let addNeedObj = {
        "family_id": OptimizationStore.selectedFamilyMemberId,
        "journey_id": getCookie(COOKIE_PARA_NAME_FOR_JOURNEY_ID),
        "need_id": selectedNeedId,
        "payout_mode": buttonType === "recommend" ? "RECOMMENDED_INCOME" :   incomeTypeEnum.INCOME.toLowerCase(),
        "target_amount": OptimizationStore.isCalculatorUsed || buttonType === "recommend" ? null : formFieldValues.target_amount_dropdown.value?.id,
        "target_value": OptimizationStore.isCalculatorUsed ? targetAmountValue : "",
        "is_calculator_used": OptimizationStore.isCalculatorUsed,
        "is_selected": true,
        "is_removed": false,
        "dob": memberData.dob,
      }
      OptimizationStore.addNeedAPICall(addNeedObj, OptimizationStore.selectedNeed, hideModal)
      return
  }
  let responseDataArray = []

  let biResponse = await axios.post(
    APITypes.FETCH_BI_DATA_BASED_ON_PROVIDED_RECOMMENDATION,
    recommendationReqDataToBeSubmitted
  )

  responseDataArray.push(biResponse.data)

  if (hideModal !== undefined) {
    hideModal()
  }

  OptimizationStore.addNeed({
    "data": responseDataArray
  })

}